import { months } from "./constants";

/** @returns {Promise<import("./context").AppState>} */
export const fetchData = () =>
  fetch("https://crm.classplus.co/su/referral/analytics")
    .then((res) => res.json())
    .then((data) => {
      console.log(data);
      /** @type {import("./context").ListItem[]} */
      const list = data.data.analytics.rows;

      return {
        totalReferrals: list.reduce((previousValue, currentValue) => previousValue + currentValue.referrals, 0),
        uniqueReferrals: list.length,
        list,
        topFiveList: list.slice(0, 5),
      };
    });

export const fetchTrends = () =>
  fetch("https://crm.classplus.co/growth/getStats")
    .then((res) => res.json())
    .then((data) => {
      let result = data.data.map((item) => {
        return {
          value: item.value,
          date: `${new Date(item.date).getDate()} ${months[new Date(item.date).getMonth()]}`,
        };
      });
      return result.reverse();
    });
